module.exports = __webpack_public_path__ + "img/SC-PROOF-999.46081029.png";